import { AbilityModule } from '@casl/angular';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';

import { SnShareModule } from '@lib/share';
import { TranslationModule } from '@lib/translation';
import { SnActionsModule } from '@lib/ui/actions';
import { SnButtonModule } from '@lib/ui/button';
import { SnIconModule } from '@lib/ui/icon';
import { SnListModule } from '@lib/ui/list';
import { SnMenuModule } from '@lib/ui/menu';

import { SnDataListModule } from '../../../ui/data-list/src/lib/data-list.module';
import {
  TagTableComponent,
  SnTagSelectionComponent,
  SnTagEditListComponent,
  SnTagViewListComponent,
  TagRecordListComponent,
  TagLocationDialogComponent,
} from './components';

@NgModule({
  exports: [
    TagTableComponent,
    TagRecordListComponent,
    SnTagEditListComponent,
    SnTagViewListComponent,
  ],
  declarations: [
    TagTableComponent,
    TagRecordListComponent,
    SnTagSelectionComponent,
    SnTagEditListComponent,
    SnTagViewListComponent,
    TagLocationDialogComponent,
  ],
  imports: [
    // Angular
    CommonModule,
    FormsModule,
    // Material
    MatChipsModule,
    MatSortModule,
    MatDialogModule,
    MatTableModule,
    MatSelectModule,
    MatTooltipModule,
    MatInputModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatProgressBarModule,
    MatButtonModule,
    MatRippleModule,
    // Others
    AbilityModule,
    // Libs
    SnMenuModule,
    SnIconModule,
    SnListModule,
    SnShareModule,
    SnButtonModule,
    SnActionsModule,
    SnDataListModule,
    TranslationModule,
  ],
})
export class SnTagsModule {}
